import { reviewUrls } from '@/api/urls/review';

import { setApiOptions } from '@/utilities/services';

import { api } from '../..';
import { PaginatedResponse } from '../models';
import { PageableParam } from '../models';
import { ReviewResponseType, ReviewsQueryParam } from './models';

import { AxiosPromise } from 'axios';

export const getReviewsByreferenceTypeService = (queryParam: ReviewsQueryParam): AxiosPromise<PaginatedResponse<ReviewResponseType[]>> => {
    const options = setApiOptions(reviewUrls.getReviewsByreferenceType, { queryParam }, false);
    return api({ ...options, method: 'GET' });
};

export const getMyReviewsService = (queryParam: PageableParam): AxiosPromise<PaginatedResponse<ReviewResponseType[]>> => {
    const options = setApiOptions(reviewUrls.getMyReviews, { queryParam }, false);
    return api({ ...options, method: 'GET' });
};
